const normalizeFormatToken = (value?: string | null) => {
  if (!value) {
    return null
  }

  return value.toLowerCase().replace(/[.\s_-]+/g, '')
}

const getTokensForEntry = (entry: { label?: string; value?: string }) => {
  return [entry.value, entry.label]
    .map((value) => normalizeFormatToken(value))
    .filter((value): value is string => !!value)
}

const getTokenPriority = (token: string): number => {
  if (token.includes('prores')) {
    return 0
  }

  if (token === 'mp4' || token === 'h264') {
    return 1
  }

  if (token === 'pngsequence' || token === 'seq') {
    return 2
  }

  return 3
}

const getFormatPriority = (entry: { label?: string; value?: string }) => {
  const tokens = getTokensForEntry(entry)

  if (tokens.length === 0) {
    return 3
  }

  let best = Number.POSITIVE_INFINITY
  for (const token of tokens) {
    best = Math.min(best, getTokenPriority(token))
  }
  return best
}

const sortFormatOptions = <T extends { label?: string; value?: string }>(options: T[]): T[] => {
  return options
    .map((option, index) => ({
      option,
      index,
      priority: getFormatPriority(option),
    }))
    .sort((a, b) => {
      if (a.priority !== b.priority) {
        return a.priority - b.priority
      }

      return a.index - b.index
    })
    .map(({ option }) => option)
}

export { normalizeFormatToken, getFormatPriority, sortFormatOptions }

